export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-status/index.js